import script from "./bottom.vue?vue&type=script&setup=true&lang=js"
export * from "./bottom.vue?vue&type=script&setup=true&lang=js"

import "./bottom.vue?vue&type=style&index=0&id=1aa62ba2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aa62ba2"]])

export default __exports__